module.exports = __webpack_public_path__ + "img/Email.87bb80ca.svg";